import { isUndefined } from 'lodash'
import { isFeatureEnabled } from '@/store/modules/feature-toggles.module'

const EMOJI_AVATAR_ATTR = 'showEmojiAvatar'

const _state = {
  isEnableAudienceAdmissionForm: false,
}

const _getters = {
  canUseToggleEmojiAvatar: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-toggle-emoji-avatar')
  },
  isEnableAudienceAdmissionForm(_, __, rootState) {
    const {
      audienceAdmission,
      disableFormJoinPresentation,
    } = rootState.presentation
    let enableAudienceAdmissionForm = false
    if (
      !disableFormJoinPresentation &&
      audienceAdmission &&
      audienceAdmission.isAudienceAdmission &&
      audienceAdmission.fields &&
      audienceAdmission.fields.length
    ) {
      audienceAdmission.fields.forEach((item) => {
        if (item.type === 'name' && !rootState.audienceName) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'email' && !rootState.audienceEmail) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'team' && !rootState.audienceTeam) {
          enableAudienceAdmissionForm = true
        }
      })
    }
    return enableAudienceAdmissionForm
  },
  isShownEmojiAvatar: (_, getters, rootState) => {
    const attrValue = rootState.presentationAttributeModule?.presentationAttribute?.[EMOJI_AVATAR_ATTR]
    // If undefined it should set to true because it's the current default value
    const showEmojiValue = isUndefined(attrValue) ? true : attrValue
    return getters.canUseToggleEmojiAvatar
      ? showEmojiValue
      : true
  },
}

const actions = {

}

const mutations = {}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
